import React from "react";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

const Stat = ({ label, value, targetId, testId }) => (
  <button
    data-testid={testId}
    onClick={() => scrollTo(targetId)}
    className="bg-white rounded-lg border border-slate-200 px-3 py-2.5 text-left hover:border-slate-400 hover:shadow-sm transition-all"
  >
    <p className="text-sm font-bold text-slate-900 truncate">{value}</p>
    <p className="text-[10px] text-slate-500 uppercase tracking-wide">{label}</p>
  </button>
);

/** Monthly Record - top summary strip (spec item 13). Every figure here is a plain
 * aggregate of data each section already independently fetched - no new vanity KPIs, and
 * clicking a tile scrolls straight to that section. */
export const MonthlySummary = ({ schedule, attendance, reconciliation, payroll, leaveLedger, medicalCheck, period }) => {
  const scheduledHours = ((schedule?.total_scheduled_minutes || 0) / 60).toFixed(1);
  const records = attendance?.daily_records || [];
  const hasWorked = records.some((r) => typeof r.worked_duration_minutes === "number");
  const approvedHours = hasWorked ? (records.reduce((s, r) => s + (r.worked_duration_minutes || 0), 0) / 60).toFixed(1) : "-";
  const paidLeaveDays = (leaveLedger || [])
    .filter((t) => t.effective_date >= `${period}-01` && t.effective_date <= `${period}-31` && t.type === "USE")
    .reduce((s, t) => s + Math.abs(t.days), 0);
  const openExceptions = (reconciliation?.days || []).filter((d) => d.status !== "WORKED_AS_SCHEDULED").length;
  const complianceBlocks = medicalCheck && ["OVERDUE", "DUE_SOON"].includes(medicalCheck.status) ? 1 : 0;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2 mb-6" data-testid="monthly-summary-strip">
      <Stat label="Scheduled hrs" value={`${scheduledHours}h`} targetId="monthly-schedule-section" testId="monthly-summary-scheduled-hours" />
      <Stat label="Approved hrs" value={approvedHours === "-" ? "-" : `${approvedHours}h`} targetId="monthly-approved-attendance-section" testId="monthly-summary-approved-hours" />
      <Stat label="Paid leave" value={`${paidLeaveDays.toFixed(1)}d`} targetId="monthly-leave-section" testId="monthly-summary-paid-leave" />
      <Stat label="Payroll status" value={payroll?.payroll_line?.status || "Pending"} targetId="monthly-payroll-section" testId="monthly-summary-payroll-status" />
      <Stat label="Gross payroll" value={payroll?.payroll_line?.gross_pay ? `¥${Number(payroll.payroll_line.gross_pay).toLocaleString()}` : "-"} targetId="monthly-payroll-section" testId="monthly-summary-gross-payroll" />
      <Stat label="Open exceptions" value={openExceptions} targetId="monthly-reconciliation-section" testId="monthly-summary-open-exceptions" />
      <Stat label="Compliance blocks" value={complianceBlocks} targetId="monthly-compliance-section" testId="monthly-summary-compliance-blocks" />
    </div>
  );
};
